import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {CardsBasicComponent} from "../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatFormField, MatFormFieldModule} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {AuthService} from "../../../shared/services/auth.service";

@Component({
  selector: 'app-password-reset',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CardsBasicComponent,
    MatFormFieldModule,
    MatFormField,
    MatInput,
    MatButton,
    FormsModule
  ],
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.css'
})
export class PasswordResetComponent implements OnInit {
  resetForm!: FormGroup;
  token: string | null = null;       // Falls Du nur einen Token verwendest
  uid: string | null = null;         // Falls Du zusätzlich eine uid verwendest
  isLoading = false;
  successMessage: string | null = null;
  errorMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Lies Token (und ggf. uid) aus den Query-Parametern
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.uid = this.route.snapshot.queryParamMap.get('uid');

    this.resetForm = new FormGroup({
      password: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required])
    });
  }

  onSubmit(): void {
    if (this.resetForm.invalid) return;
    this.isLoading = true;
    this.errorMessage = null;
    this.successMessage = null;

    const password = this.resetForm.value.password;
    const confirmPassword = this.resetForm.value.confirmPassword;
    if (password !== confirmPassword) {
      this.errorMessage = 'Passwords do not match.';
      this.isLoading = false;
      return;
    }

    this.authService.resetPassword(this.token, this.uid, password).subscribe({
      next: (res: any) => {
        this.successMessage = 'Your password has been reset successfully.';
        this.isLoading = false;
        setTimeout(() => {
          this.router.navigate(['/en/login']);
        }, 2000);
      },
      error: (err: any) => {
        this.errorMessage = err.error?.detail || 'An error occurred. Please try again.';
        this.isLoading = false;
      }
    });

    // Beispiel-URL: passe sie an Deine API an
    /*
    this.http.post('/api/auth/password-reset/confirm/', {
      token: this.token,
      uid: this.uid,
      new_password: password
    }).subscribe({
      next: (res: any) => {
        this.successMessage = 'Your password has been reset successfully.';
        this.isLoading = false;
        // Weiterleitung zum Login
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000);
      },
      error: (err: any) => {
        this.errorMessage = err.error?.detail || 'An error occurred. Please try again.';
        this.isLoading = false;
      }
    });

     */
  }
}
